"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosGRNCreateInputSchema = exports.APosGRNSchema = exports.APosGRNItemSchema = exports.APosGRNStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosGRNStatusSchema = zod_1.z.enum(['draft', 'completed', 'cancelled']);
exports.APosGRNItemSchema = zod_1.z.object({
    itemId: id_schema_1.EntityIdSchema,
    variantId: id_schema_1.EntityIdSchema,
    displayName: zod_1.z.string().optional(),
    sku: zod_1.z.string().optional(),
    quantity: zod_1.z.number().int().positive(),
    costPrice: zod_1.z.number().nonnegative(),
    totalCost: zod_1.z.number().nonnegative(),
    expiryDate: zod_1.z.number().optional(),
    batchNumber: zod_1.z.string().optional(),
});
exports.APosGRNSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    grnId: id_schema_1.EntityIdSchema,
    receivedDate: zod_1.z.number(),
    receivedBy: id_schema_1.EntityIdSchema,
    supplierId: id_schema_1.EntityIdSchema.optional(),
    purchaseOrderId: id_schema_1.EntityIdSchema.optional(),
    invoiceNumber: zod_1.z.string().optional(),
    notes: zod_1.z.string().max(2000).optional(),
    items: zod_1.z.array(exports.APosGRNItemSchema).min(1),
    totalItems: zod_1.z.number().int().nonnegative(),
    totalCost: zod_1.z.number().nonnegative(),
    status: exports.APosGRNStatusSchema.default('draft'),
    completedAt: zod_1.z.number().optional(),
    completedBy: id_schema_1.EntityIdSchema.optional(),
    cancelledAt: zod_1.z.number().optional(),
    cancelledBy: id_schema_1.EntityIdSchema.optional(),
    cancelReason: zod_1.z.string().max(500).optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosGRNCreateInputSchema = zod_1.z.object({
    locationId: id_schema_1.EntityIdSchema,
    supplierId: id_schema_1.EntityIdSchema.optional(),
    purchaseOrderId: id_schema_1.EntityIdSchema.optional(),
    invoiceNumber: zod_1.z.string().optional(),
    notes: zod_1.z.string().max(2000).optional(),
    items: zod_1.z.array(zod_1.z.object({
        variantId: id_schema_1.EntityIdSchema,
        displayName: zod_1.z.string().optional(),
        sku: zod_1.z.string().optional(),
        quantity: zod_1.z.number().int().positive(),
        costPrice: zod_1.z.number().nonnegative(),
        expiryDate: zod_1.z.number().optional(),
        batchNumber: zod_1.z.string().optional(),
    })).min(1),
});
//# sourceMappingURL=grn.schema.js.map